import { Redirect, Route, RouteProps, useLocation } from 'react-router-dom';

const isAuthenticated: () => Boolean = () => {
  const token = localStorage.getItem('token');

  return Boolean(token);
};

interface PrivateRouterProps extends RouteProps {
  redirectPath?: string;
}

const PrivateRouter: React.FC<PrivateRouterProps> = ({
  children,
  redirectPath = '/',
  ...rest
}) => {
  const location = useLocation();
  if (!isAuthenticated()) {
    const { search } = location;
    if (search === '?from-members') {
      return <Redirect to="/sign-in?from-members" />;
    }
    return (
      <Redirect
        to={{
          pathname: redirectPath,
          state: { from: location },
        }}
      />
    );
  }

  return <Route {...rest}>{children}</Route>;
};

export default PrivateRouter;
